import React from "react";
import { useSelector } from "react-redux";
import "./main.css";

const Home = () => {
  // Getting User Data from Redux Store
  const myData = useSelector((state) => state.user);
  console.log("Home", myData);

  return (
    <>
      <section className="header">
        <div className="header_text">
          <h3>Welcome to Websole</h3>
          <p>Business Solution & Services Pvt Ltd.</p>
        </div>
      </section>
      <section className="home_service main1">
        <h3>What We Offer</h3>
        <h5>We make good engineers. They, in turn, make good software.</h5>
        <p>
          Nextbridge is a software development company based in Lahore, Pakistan
          that is devoted to providing innovative software solutions to
          startups, SMBs, and large enterprises. Partnering with us will help
          you obtain a competitive edge in the market through high-quality
          custom development services. The most influential design, business,
          and technology talents that exist in the business will be made
          available to you. You demonstrate your idea and together we will learn
          about the right audiences, test solutions, and execute them based on
          the right standards.
        </p>
      </section>

      <div className="home_cards main2">
        <h3>What We Offer</h3>
        <p>
          Nextbridge is a software development company based in Lahore, Pakistan
          that is devoted to providing innovative software solutions to
          startups, SMBs, and large enterprises. Partnering with us will help
          you obtain a competitive edge in the market through high-quality
          custom development services. The most influential design, business,
          and technology talents that exist in the business will be made
          available to you. You demonstrate your idea and together we will learn
          about the right audiences, test solutions, and execute them based on
          the right standards.
        </p>
        <div className="main_cards">
          <div className="card-1 card">
            <i class="fa-solid fa-laptop-code"></i>
            <h2>Custom Software development</h2>
          </div>
          <div className="card-2 card">
            <i class="fa-solid fa-laptop-code"></i> <h2> Web development</h2>
          </div>
          <div className="card-3 card">
            <i class="fa-solid fa-mobile"></i>
            <h2>Mobile development</h2>
          </div>
          <div className="card-4 card">
            <i class="fa-solid fa-file-code"></i>
            <h2>UI/UX Design</h2>
          </div>
          <div className="card-5 card">
            <i class="fa-solid fa-screwdriver-wrench"></i>
            <h2>DevOps</h2>
          </div>
          <div className="card-6 card">
            <i class="fa-solid fa-gears"></i>
            <h2>Support & Maintenance</h2>
          </div>
        </div>
      </div>

      <section className="why-websole main3">
        <h3>Why Websole</h3>
        <p>
          As an innovative software development company, building powerful
          digital solutions and experiences is what we do. It is not just our
          expertise that differentiates us from others, but also our
          relationship with clients. Our approach is cross-functional
          collaboration and constant improvement. Our investment in clients
          means they don’t just receive a team of highly experienced developers,
          but also the support and insights of accomplished engineers and
          business analysts.
        </p>
      </section>
    </>
  );
};

export default Home;
